// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Sort: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10">
            <path
                fill="currentColor"
                d="M0.594260875,4.12558025 L6.2811752,4.12558025 C6.80969096,4.12558025 7.07373345,3.48577559 6.70098007,3.11323661 L3.85859719,0.174174368 C3.74245254,0.0580297112 3.59068701,0 3.43900738,0 C3.28743527,0 3.13629261,0.0580297112 3.02113635,0.174174368 L0.174434696,3.11366606 C-0.198276397,3.48534581 0.0656375923,4.12558025 0.594260547,4.12558025 L0.594260875,4.12558025 Z M6.27988521,5.50058025 L0.594260547,5.50058025 C0.0657447913,5.50058025 -0.198298033,6.14016986 0.174456004,6.5129239 L3.02113569,9.45198613 C3.13457317,9.56757218 3.26777655,9.62558025 3.43750298,9.62558025 C3.58903215,9.62558025 3.74086225,9.56750792 3.8570928,9.45136327 L6.69947601,6.51230103 C7.0726595,6.14081436 6.80840129,5.50058025 6.27988553,5.50058025 L6.27988521,5.50058025 Z"
                transform="translate(0 .062)"
            />
        </svg>
    );
};

export default React.memo(Sort);
